import { ArrowRight } from '@liveauctioneers/hammer-ui-core/icons';
import { BodyPrimary, H1 } from '@liveauctioneers/hammer-ui-core/text';
import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useWindowIsMobile } from '@liveauctioneers/hammer-ui-core/providers';

type HowToWinBannerBigContentProps = {
    href: string;
    onCTAClick: () => void;
};

export const HowToWinBannerBigContent = ({ href, onCTAClick }: HowToWinBannerBigContentProps) => {
    const { formatMessage } = useIntl();
    const isMobile = useWindowIsMobile();

    return (
        <div className="flex min-w-0 flex-col items-center gap-xs text-center smMin:flex-1 smMin:items-start smMin:gap-md smMin:text-left">
            <div>
                <H1 className="mb-2xs text-text-primary smMin:mb-xs">
                    {formatMessage({ id: 'howToWinBanner.headline' })}
                </H1>
                <BodyPrimary className="smMax:hui-text-body-secondary">
                    {formatMessage({ id: 'howToWinBanner.subheadline' })}
                </BodyPrimary>
            </div>
            <Button
                as="a"
                className="w-fit"
                href={href}
                iconRight={ArrowRight}
                onClick={onCTAClick}
                size={isMobile ? 'sm' : 'md'}
                style="primary"
                variant="outlined"
            >
                {formatMessage({ id: 'howToWinBanner.cta' })}
            </Button>
        </div>
    );
};
